<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>      
                {{ 'Groups' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Group name' | translate"
                            v-model="group_name"
                            name="group_name"
                            autocomplete="off"
                            :rules="groupnameRules"
                            :disabled="(isUser? true : false)"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="users_data"
                              :items="groupusers"
                              item-value="user_id"
                              :item-text="item =>`${item.name} (${item.email})`"
                              :label="'Users' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              required
                              :disabled="(isUser? true : false)"
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>  

                            </v-autocomplete>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="courses_data"
                              :items="courses"
                              item-value="course_id"
                              item-text="course_name"
                              :label="'Courses' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              :disabled="(isUser? true : false)"
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>  
                            </v-autocomplete>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="group_admins"
                              :items="groupusers"
                              item-value="user_id"
                              :item-text="item =>`${item.name} (${item.email})`"
                              :label="'Group admins' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              required
                              :disabled="(isUser? true : false)"
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                           
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="documents"
                              :items="personaldocuments"
                              item-value="temp_id"
                              item-text="temp_name"
                              :label="'User documents' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="equip_groups"
                              :items="equipmentgroupdata"
                              item-value="equip_group_id"
                              item-text="equip_group_name"
                              :label="'Equipment group' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="tc_groups"
                              :items="testgroup"
                              item-value="tc_group_id"
                              item-text="tc_group_name"
                              :label="'Task group' | translate"
                              outlined
                              chips
                              small-chips
                              multiple
                              :no-data-text="$t('No data available')"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                              
                            </v-autocomplete>
                        </v-col>
                      </v-row>





                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="group_id == null && !isUser"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="group_id && !isUser"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
       </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>  

<script>
import {
  ADD_GROUP,
  FETCH_INDIVIDUAL_GROUP,
  FETCH_PERSONAL_DOCUMENTS,
  FETCH_GROUP_USERS,
  FETCH_EQUIPMENT_GROUP_DATA,
  UPDATE_GROUP,
  FETCH_TEST_GROUP,
  FETCH_COURSES,
  RESET_STATE
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addeditGroups",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE)
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    Promise.all([
        await store.dispatch(FETCH_TEST_GROUP,''), 
        await store.dispatch(FETCH_EQUIPMENT_GROUP_DATA, ""),
        await store.dispatch(FETCH_GROUP_USERS, ''),
        await store.dispatch(FETCH_COURSES,''),
        await store.dispatch(FETCH_PERSONAL_DOCUMENTS)
        
    ]).then(() => {
        store.commit(SET_LOADING, false)
      })     
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_GROUP, to.params.id)
      
    }
    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE)
    next();
  },
  computed: {
    ...mapGetters(['testgroup','individualgroup', 'equipmentgroupdata','personaldocuments','groupusers','courses', 'currentUser', 'curLanguage']),
    ...mapState({
      errors: state => state.groups.grouperrors
    }),
    groupnameRules(){  return [v => !!v || "Group name is required"]},
    isUser(){
      return this.currentUser.roles.includes(4) 
    }, 

  },
  created () {
    if(this.currentUser.roles.includes(1) == false){
      this.$router.push('/dashboard');
    }
    if(Object.keys(this.individualgroup).length >0){
      this.group_id = this.individualgroup.group_id
      this.group_name =   this.individualgroup.group_name
      this.users_data =   this.individualgroup.users
      this.group_admins   =   this.individualgroup.group_admins
      this.courses_data   =   this.individualgroup.courses
      this.documents      = this.individualgroup.documents
      this.equip_groups = this.individualgroup.equip_groups
      this.tc_groups  = this.individualgroup.tc_groups
    }
  },
  data: function() {
    return {
      group_id: null,
      group_name: null,
      group_admins:[],
      users_data:[],
      courses_data: [],
      documents: [],
      equip_groups: [],
      tc_groups: []
    }
  },
  methods : {
    customFilter(item, queryText){
      const name = item.name.toLowerCase()
      const email = item.email.toLowerCase()  
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) > -1 || email.indexOf(searchText) > -1 
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        let data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
            documents: this.documents,
            equip_groups: this.equip_groups,
            tc_groups:this.tc_groups
          }

        if(this.documents.length == 0){
          data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
            equip_groups: this.equip_groups,
            tc_groups:this.tc_groups
          }
        }

        this.$store
          .dispatch(ADD_GROUP, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Group created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "groups" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {

        let data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
            documents: this.documents, 
            equip_groups: this.equip_groups, 
            tc_groups:this.tc_groups,          
            _method: "put"
          };

        if(this.documents.length == 0){
          data = {
            group_name: this.group_name,
            group_id: this.group_id,
            users: this.users_data,
            courses: this.courses_data,
            group_admins: this.group_admins,
            equip_groups: this.equip_groups,
            tc_groups: this.tc_groups,
            _method: "put"
          }
        }

        this.$store
          .dispatch(UPDATE_GROUP, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Group updated successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "groups" })
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    }

  },
};
</script>